import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDocumentReviewSmall(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        width={38.1}
        height={47.1}
        x={10.95}
        y={6.52}
        stroke="url(#document_review_small_svg__a)"
        strokeWidth={5.01}
        rx={8.02}
      />
      <path stroke="#0D2B57" strokeWidth={0.5} d="M19.48 17.3h21.05m-21.05 5.01h21.05" />
      <mask
        id="document_review_small_svg__b"
        width={23}
        height={23}
        x={35}
        y={33}
        fill="#000"
        maskUnits="userSpaceOnUse"
      >
        <path fill="#fff" d="M35 33h23v23H35z" />
        <path d="m49.88 46.47 6.47 6.26-1.76 1.78-6.44-6.28c-2.09 1.39-4.36 1.78-6.78 1.12-1.76-.49-3.16-1.51-4.22-2.98-2.13-2.98-1.73-7.16.91-9.71 1.33-1.29 3.1-2.06 4.97-2.19a7.97 7.97 0 0 1 5.23 1.51c3.03 2.21 4.32 7 1.61 10.48" />
      </mask>
      <path
        fill="#0D2B57"
        d="m49.88 46.47 6.47 6.26-1.76 1.78-6.44-6.28c-2.09 1.39-4.36 1.78-6.78 1.12-1.76-.49-3.16-1.51-4.22-2.98-2.13-2.98-1.73-7.16.91-9.71 1.33-1.29 3.1-2.06 4.97-2.19a7.97 7.97 0 0 1 5.23 1.51c3.03 2.21 4.32 7 1.61 10.48"
      />
      <path
        stroke="#fff"
        strokeWidth={1.01}
        d="m49.88 46.47 6.47 6.26-1.76 1.78-6.44-6.28c-2.09 1.39-4.36 1.78-6.78 1.12-1.76-.49-3.16-1.51-4.22-2.98-2.13-2.98-1.73-7.16.91-9.71 1.33-1.29 3.1-2.06 4.97-2.19a7.97 7.97 0 0 1 5.23 1.51c3.03 2.21 4.32 7 1.61 10.48Z"
        mask="url(#document_review_small_svg__b)"
      />
      <defs>
        <linearGradient
          id="document_review_small_svg__a"
          x1={30}
          x2={30}
          y1={6.52}
          y2={53.65}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#98CCFB" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDocumentReviewSmall);
export default ForwardRef;
